<template>
  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <WdsText :sub-text="jobId">{{ jobTitle }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { WdsText } from '@worksome/wds-components'

defineProps<{
  jobTitle: string
  jobId: string
}>()
</script>

<style scoped></style>
